export default __webpack_public_path__ + "static/media/pt-serif-v12-latin-regular.751bb457.ttf";